/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationConclusionAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_CANCEL_REQUEST = 'button-cancel-request',
  BUTTON_SEND = 'button-send',
  CARD_0 = 'card-0',
  FETCH_0 = 'fetch-0',
  FETCH_FINAL_MESSAGE = 'fetch-final-message',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_PENDENCY = 'field-pendency',
  FIELD_TERM = 'field-term',
  FORM_0 = 'form-0',
  FORM_CANCEL_REQUEST = 'form-cancel-request',
  HPMS_TERM_CHECKBOX = 'hpms-term-checkbox',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LOADER_0 = 'loader-0',
  LOADER_PENDENCIES = 'loader-pendencies',
  MAPPER_0 = 'mapper-0',
  MODAL_REASON_FOR_CANCELING_ACCREDITATION = 'modal-reason-for-canceling-accreditation',
  MODAL_TERM_FORM = 'modal-term-form',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_BUTTONS = 'panel-buttons',
  PANEL_CANCEL = 'panel-cancel',
  PANEL_CONCLUSION = 'panel-conclusion',
  PANEL_FINAL_MESSAGE = 'panel-final-message',
  PANEL_LOADER = 'panel-loader',
  PANEL_LOADER_PENDENCIES = 'panel-loader-pendencies',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_REPEATER = 'panel-repeater',
  PANEL_TERM = 'panel-term',
  PANEL_TITLE = 'panel-title',
  REPEATER_PENDENCIES = 'repeater-pendencies',
  TERM_FORM_PROVIDER_ACCREDITATION = 'term-form-provider-accreditation',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_HEADER = 'text-header',
  TEXT_PENDENCY = 'text-pendency',
}
export { ProviderAccreditationConclusionAliases };
